import { default as _91companyId_93vuYpKKiaqbMeta } from "/home/ec2-user/biz_partners_frontend/src/pages/company/[companyId].vue?macro=true";
import { default as indexRz012YlMeiMeta } from "/home/ec2-user/biz_partners_frontend/src/pages/company/index.vue?macro=true";
import { default as indexpgYQrp2jMGMeta } from "/home/ec2-user/biz_partners_frontend/src/pages/index.vue?macro=true";
export default [
  {
    name: "company-companyId",
    path: "/company/:companyId()",
    component: () => import("/home/ec2-user/biz_partners_frontend/src/pages/company/[companyId].vue").then(m => m.default || m)
  },
  {
    name: "company",
    path: "/company",
    component: () => import("/home/ec2-user/biz_partners_frontend/src/pages/company/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ec2-user/biz_partners_frontend/src/pages/index.vue").then(m => m.default || m)
  }
]